import CLOUD_EXT_1 from "./CLOUD_EXT_1";
export default {
  CLOUD_EXT_1,
};
